module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Precio":"Precio"},"en":{"Precio":"Price"},"ca":{"Precio":"Preu"}}')
  delete Component.options._Ctor
}
